var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 291.357,
    height: 280.952,
    viewBox: "0 0 291.357 280.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M262.23,60.793a13.7,13.7,0,0,0-1.4.072,17.064,17.064,0,0,0-5.2,1.542c-1.612.739-3.094,1.608-4.569,2.446s-3,1.733-4.506,2.726a25.661,25.661,0,0,0-8.067,7.8,16.544,16.544,0,0,0-2.131,5.5,13.136,13.136,0,0,0-.233,3.009,11.136,11.136,0,0,0,.5,3.022,11.775,11.775,0,0,0,3.211,5.086,21.254,21.254,0,0,0,4.66,3.294,70.832,70.832,0,0,0,9.911,4.188c6.6,2.279,13,4.033,18.463,6.543a37.1,37.1,0,0,1,12.874,9.259,25.9,25.9,0,0,1,3.469,5.1q.294.618.568,1.195c.167.39.3.778.438,1.143a17.828,17.828,0,0,1,.623,2.055,17.1,17.1,0,0,1,.45,2.946l.07,1.045s-.008-.361-.025-1.047a17.144,17.144,0,0,0-.328-2.98,17.952,17.952,0,0,0-.543-2.1c-.128-.376-.243-.776-.4-1.179l-.527-1.235a26.245,26.245,0,0,0-3.323-5.338,37.852,37.852,0,0,0-12.809-9.994c-5.483-2.775-11.893-4.792-18.317-7.271q-2.408-.935-4.794-2c-1.57-.735-3.161-1.5-4.648-2.372a18.981,18.981,0,0,1-4.029-3.042,9.17,9.17,0,0,1-2.4-4.053,11.684,11.684,0,0,1,1.845-9.158,14.117,14.117,0,0,1,1.481-1.929,19.252,19.252,0,0,1,1.765-1.731,30.617,30.617,0,0,1,4.043-2.934c1.424-.888,2.906-1.7,4.39-2.5,1.5-.805,2.938-1.6,4.344-2.2a13.572,13.572,0,0,1,4.114-1.145,4.881,4.881,0,0,1,.638-.025c.11,0,.221,0,.332,0,.319,0,.636.057.952.075.312.066.627.114.933.194.3.1.614.159.905.292a10.1,10.1,0,0,1,5.307,4.721,8.63,8.63,0,0,1,.693,6.035,9.806,9.806,0,0,1-1.028,2.644,10.629,10.629,0,0,1-1.573,2.167,9.747,9.747,0,0,1-3.959,2.585,8.229,8.229,0,0,1-3.987.331,5.315,5.315,0,0,1-2.815-1.391,4.97,4.97,0,0,1-1.284-2.34,4.815,4.815,0,0,1-.107-1.151,3.61,3.61,0,0,1,.193-.995,3.236,3.236,0,0,1,2.351-2.022A5.009,5.009,0,0,1,260,75.518a4.151,4.151,0,0,1,2.064.631,2.24,2.24,0,0,0,.45.257c.085.03.112.014.112.014s.028-.013.035-.1a1.425,1.425,0,0,0-.119-.563,3.017,3.017,0,0,0-1.017-1.208,4.811,4.811,0,0,0-3.021-.849,5.676,5.676,0,0,0-2.33.609,5.12,5.12,0,0,0-1.234.879,6.75,6.75,0,0,0-.558.643,6.112,6.112,0,0,0-.447.738,7.232,7.232,0,0,0,1.181,7.842,8.51,8.51,0,0,0,4.547,2.671,11.538,11.538,0,0,0,5.866-.227,13.231,13.231,0,0,0,5.667-3.5,14.194,14.194,0,0,0,2.19-2.946,13.466,13.466,0,0,0,1.434-3.66,12.991,12.991,0,0,0,.288-4.288,12.2,12.2,0,0,0-1.365-4.47,13.821,13.821,0,0,0-7.479-6.469,13.427,13.427,0,0,0-1.292-.389c-.441-.107-.9-.174-1.35-.252-.434-.028-.868-.086-1.308-.086h-.086",
    transform: "translate(-236.114 -60.792)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M279.115,94.188l-.147,7.429-.291,14.856q-.228,14.856-.377,29.712c-.119,9.9-.146,19.808-.217,29.712l-.072,29.713.069,29.713c.073,9.9.1,19.809.217,29.713q.132,14.856.377,29.711l.293,14.857.148,7.429.2,7.427.2-7.427.148-7.429.293-14.857q.227-14.856.377-29.711c.122-9.9.144-19.809.217-29.713l.069-29.713-.072-29.713c-.07-9.9-.1-19.808-.217-29.712q-.131-14.856-.377-29.712l-.29-14.856-.148-7.429-.2-7.428Z",
    transform: "translate(-278.011 -86.76)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M269.179,186.161a6.615,6.615,0,1,0,6.615-6.615,6.614,6.614,0,0,0-6.615,6.615",
    transform: "translate(-269.179 -179.546)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M275.282,291.495a2.942,2.942,0,1,0,2.942-2.943,2.942,2.942,0,0,0-2.942,2.943",
    transform: "translate(-275.282 -288.552)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M272.986,394.828c1.73-.146,4.542,2.23,4.688,3.959-.146-1.73,2.23-4.543,3.96-4.689-1.73.146-4.543-2.23-4.689-3.959.146,1.73-2.23,4.543-3.959,4.689",
    transform: "translate(-272.986 -390.139)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M268.291,243.034c2.86-.241,7.511,3.686,7.752,6.546-.241-2.86,3.687-7.51,6.546-7.752-2.859.242-7.511-3.687-7.752-6.546.241,2.859-3.687,7.511-6.546,7.752",
    transform: "translate(-268.291 -235.282)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M319.384,15.132a16.542,16.542,0,0,0-5.5,2.131,25.654,25.654,0,0,0-7.8,8.068c-.994,1.5-1.876,3.022-2.726,4.506s-1.707,2.957-2.446,4.569a17.085,17.085,0,0,0-1.541,5.2,13.546,13.546,0,0,0-.072,1.4c-.008.469.055.931.085,1.393.077.453.145.909.251,1.35a13.394,13.394,0,0,0,.39,1.291,13.819,13.819,0,0,0,6.469,7.479,12.191,12.191,0,0,0,4.47,1.366,13,13,0,0,0,4.288-.289,13.467,13.467,0,0,0,3.66-1.434,14.2,14.2,0,0,0,2.946-2.189,13.237,13.237,0,0,0,3.5-5.667,11.539,11.539,0,0,0,.227-5.866,8.506,8.506,0,0,0-2.671-4.547,7.234,7.234,0,0,0-7.841-1.182,6.356,6.356,0,0,0-.738.447,6.671,6.671,0,0,0-.643.558,5.137,5.137,0,0,0-.879,1.234,5.674,5.674,0,0,0-.609,2.33,4.808,4.808,0,0,0,.849,3.021,3.01,3.01,0,0,0,1.208,1.016,1.414,1.414,0,0,0,.564.12c.087-.007.1-.036.1-.036s.016-.026-.014-.112a2.259,2.259,0,0,0-.256-.45,4.147,4.147,0,0,1-.631-2.064,5,5,0,0,1,.146-1.247,3.237,3.237,0,0,1,2.021-2.35,3.617,3.617,0,0,1,.995-.193,4.82,4.82,0,0,1,1.152.108,4.976,4.976,0,0,1,2.34,1.284,5.318,5.318,0,0,1,1.39,2.815,8.239,8.239,0,0,1-.33,3.986,9.738,9.738,0,0,1-2.585,3.96,10.6,10.6,0,0,1-2.166,1.574,9.8,9.8,0,0,1-2.644,1.028,8.628,8.628,0,0,1-6.034-.693,10.1,10.1,0,0,1-4.721-5.307c-.134-.291-.189-.6-.293-.9-.08-.308-.128-.621-.194-.934-.019-.315-.079-.634-.076-.952s-.014-.634.028-.969a13.576,13.576,0,0,1,1.145-4.115c.6-1.406,1.394-2.845,2.2-4.344s1.614-2.966,2.5-4.39a30.641,30.641,0,0,1,2.935-4.043,19.1,19.1,0,0,1,1.731-1.764,14.16,14.16,0,0,1,1.929-1.48A11.681,11.681,0,0,1,324.654,18a9.169,9.169,0,0,1,4.052,2.4,18.969,18.969,0,0,1,3.042,4.03c.871,1.486,1.637,3.077,2.372,4.648q1.071,2.381,2,4.794c2.479,6.423,4.5,12.834,7.27,18.317A37.862,37.862,0,0,0,353.389,65a26.269,26.269,0,0,0,5.339,3.323l1.236.527c.4.153.8.268,1.177.4a18.266,18.266,0,0,0,2.1.543,17.246,17.246,0,0,0,2.981.327l1.047.025-1.044-.069a17.273,17.273,0,0,1-2.946-.45A17.867,17.867,0,0,1,361.225,69c-.366-.141-.755-.271-1.145-.438l-1.194-.568a25.906,25.906,0,0,1-5.1-3.469,37.1,37.1,0,0,1-9.259-12.874c-2.511-5.467-4.264-11.858-6.543-18.463a70.867,70.867,0,0,0-4.188-9.911,21.306,21.306,0,0,0-3.294-4.66,11.782,11.782,0,0,0-5.086-3.211,11.149,11.149,0,0,0-3.022-.5q-.244-.008-.486-.008a12.855,12.855,0,0,0-2.523.241",
    transform: "translate(-299.302 -14.891)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M414.407,56.861c-9.9.07-19.808.1-29.713.217q-14.857.13-29.712.377l-14.857.291-7.427.148-7.429.195,7.429.2,7.427.147,14.857.291q14.857.228,29.712.377c9.9.119,19.808.146,29.713.217l29.712.072,29.712-.069c9.9-.073,19.809-.1,29.713-.217q14.857-.132,29.713-.377l14.856-.293,7.427-.147,7.429-.2-7.429-.2-7.427-.149-14.856-.292q-14.857-.227-29.713-.377c-9.9-.121-19.809-.144-29.713-.216l-29.712-.069Z",
    transform: "translate(-325.269 -56.789)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M418.056,54.571a6.615,6.615,0,1,0,6.615-6.616,6.615,6.615,0,0,0-6.615,6.616",
    transform: "translate(-418.056 -47.955)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M527.062,57A2.942,2.942,0,1,0,530,54.059,2.942,2.942,0,0,0,527.062,57",
    transform: "translate(-527.062 -54.059)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M628.648,55.722c1.73.146,4.105,2.959,3.959,4.689.146-1.73,2.96-4.1,4.689-3.959-1.729-.146-4.106-2.959-3.959-4.689-.146,1.73-2.959,4.106-4.689,3.959",
    transform: "translate(-628.648 -51.763)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M473.791,53.615c2.859.241,6.787,4.892,6.546,7.752.241-2.86,4.893-6.788,7.751-6.546-2.859-.241-6.787-4.893-6.546-7.752-.241,2.859-4.892,6.787-7.751,6.546",
    transform: "translate(-473.791 -47.069)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M276.564,32.261c-.066.174-.132.351-.2.529-.307-.177-.614-.35-.917-.516-1.549-.849-3.019-1.542-4.1-2.015s-1.772-.743-1.772-.743l1.854,6.085.316,1.021c-.514.093-1.026.2-1.521.311a44.949,44.949,0,0,0-4.836,1.378s1.555,1.741,3.382,3.631,3.923,3.931,5.345,4.421a2.5,2.5,0,0,0,2.578-.678,4.63,4.63,0,0,0,2.174.05,7.973,7.973,0,0,0,2.479-.97,7.338,7.338,0,0,0,1.9-1.866,4.037,4.037,0,0,0,.76-2.762,2.657,2.657,0,0,0,1.348-2.7c-.286-1.477-2.018-3.83-3.627-5.913s-3.122-3.858-3.122-3.858a45.075,45.075,0,0,0-2.043,4.594",
    transform: "translate(-265.392 -27.667)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M290.225,143.733a5.9,5.9,0,0,0-2.321,2.415,7.252,7.252,0,0,0-.8,3.635,9.113,9.113,0,0,0,1.077,3.836c.606,1.2,1.341,2.3,2.006,3.451a82.938,82.938,0,0,1,6.9,14.949,58.6,58.6,0,0,1,2.076,7.276,16.147,16.147,0,0,1,.123,6.161,14.487,14.487,0,0,1-1.366,3.986c-.232.445-.431.782-.572,1.007l-.218.342.233-.332c.15-.22.364-.547.617-.985a14.546,14.546,0,0,0,1.548-3.969,16.408,16.408,0,0,0,.128-6.3,58.021,58.021,0,0,0-1.816-7.436,80.376,80.376,0,0,0-6.487-15.366c-.651-1.2-1.357-2.322-1.876-3.421a7.718,7.718,0,0,1-.853-3.244,5.8,5.8,0,0,1,.67-2.857,4.4,4.4,0,0,1,1.72-1.775,4.452,4.452,0,0,1,2.052-.583,3.588,3.588,0,0,1,1.757.4,3.832,3.832,0,0,1,1.816,2.289,3.6,3.6,0,0,1-.043,2.156,4.57,4.57,0,0,1-.715,1.36,7.971,7.971,0,0,1-1.037,1.071c-.167.155-.15.2-.15.2s.013.048.253.023a2.972,2.972,0,0,0,1.5-.746,4.534,4.534,0,0,0,1.488-4.382,5.035,5.035,0,0,0-2.372-3.3,4.843,4.843,0,0,0-2.474-.646,5.794,5.794,0,0,0-2.86.769",
    transform: "translate(-287.094 -142.964)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M301.017,160.26a4.607,4.607,0,0,0,.487.939,4.2,4.2,0,0,0,1.814,1.568.957.957,0,0,0,1.059-.113.709.709,0,0,0,.2-.365.927.927,0,0,0-.049-.413.992.992,0,0,0-.655-.595,11.563,11.563,0,0,1-1.832-.666,5.892,5.892,0,0,1-1.16-.766,3.773,3.773,0,0,0,.137.41",
    transform: "translate(-300.88 -159.85)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M300.571,165.223a.8.8,0,1,0,1.169-1.071,16.62,16.62,0,0,0-2.809-1.893,16.528,16.528,0,0,0,1.641,2.964",
    transform: "translate(-298.93 -162.259)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M293.726,158.122a.812.812,0,0,0-.81.808.774.774,0,0,0,.879.775,5.511,5.511,0,0,0,1.8-.569,9.643,9.643,0,0,0,1.075-.6l-1.19-.188a13.6,13.6,0,0,0-1.694-.232h-.061",
    transform: "translate(-292.916 -158.121)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M295.625,162.578c-.363.363.2.923.2.923s.56.561.923.2a5.93,5.93,0,0,0,.7-1.822,5.916,5.916,0,0,0-1.821.7",
    transform: "translate(-295.503 -161.876)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M301.087,157.964a1.939,1.939,0,0,0-1.009.356,1.024,1.024,0,0,0-.286.309,1.069,1.069,0,0,1,.377-.079,1.641,1.641,0,0,1,.8.2c.283.14.59.351.916.531a6.667,6.667,0,0,0,.8.4.891.891,0,0,0,.87-.052.954.954,0,0,0,.285-.3.758.758,0,0,0,.075-.407.9.9,0,0,0-.669-.723,4.05,4.05,0,0,0-.953-.2c-.262-.023-.562-.055-.871-.055-.111,0-.224,0-.337.014",
    transform: "translate(-299.792 -157.95)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M386.516,69.977A5.9,5.9,0,0,0,384.1,72.3a5.394,5.394,0,0,0-.123,5.334,5.038,5.038,0,0,0,3.3,2.372,4.539,4.539,0,0,0,4.382-1.488,2.975,2.975,0,0,0,.746-1.5c.025-.24-.023-.253-.023-.253s-.046-.018-.2.149a7.869,7.869,0,0,1-1.072,1.037,4.552,4.552,0,0,1-1.359.715,3.581,3.581,0,0,1-2.156.043,3.831,3.831,0,0,1-2.289-1.816,3.57,3.57,0,0,1-.4-1.757,4.442,4.442,0,0,1,2.357-3.772,5.806,5.806,0,0,1,2.858-.67,7.732,7.732,0,0,1,3.243.853c1.1.52,2.221,1.225,3.421,1.876A80.364,80.364,0,0,0,412.142,79.9a57.987,57.987,0,0,0,7.437,1.816,16.4,16.4,0,0,0,6.3-.128,14.58,14.58,0,0,0,3.969-1.548c.436-.252.764-.466.984-.617l.332-.233-.342.218c-.226.141-.562.341-1.007.573a14.535,14.535,0,0,1-3.987,1.364,16.12,16.12,0,0,1-6.161-.123,58.54,58.54,0,0,1-7.276-2.076,82.849,82.849,0,0,1-14.948-6.9c-1.153-.666-2.251-1.4-3.451-2.007a9.108,9.108,0,0,0-3.836-1.076q-.143-.005-.285-.005a7.22,7.22,0,0,0-3.35.81",
    transform: "translate(-383.332 -69.167)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M400.983,84.112a11.667,11.667,0,0,1,.666,1.832.989.989,0,0,0,.594.655.933.933,0,0,0,.413.049.714.714,0,0,0,.365-.2.957.957,0,0,0,.113-1.059,4.209,4.209,0,0,0-1.568-1.815,4.628,4.628,0,0,0-.94-.487,4.043,4.043,0,0,0-.409-.137,5.88,5.88,0,0,1,.766,1.16",
    transform: "translate(-400.217 -82.952)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M404.52,83.811a.805.805,0,1,0,1.071-1.168A16.506,16.506,0,0,0,402.628,81a16.557,16.557,0,0,0,1.892,2.809",
    transform: "translate(-402.628 -81.002)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M399.3,74.989a.812.812,0,0,0-.808.809,11.846,11.846,0,0,0,.231,1.755l.188,1.192a9.832,9.832,0,0,0,.6-1.076,5.542,5.542,0,0,0,.568-1.8.772.772,0,0,0-.774-.879h0",
    transform: "translate(-398.489 -74.989)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M402.945,77.7a5.915,5.915,0,0,0-.7,1.82,5.926,5.926,0,0,0,1.82-.7c.363-.363-.2-.923-.2-.923a1.115,1.115,0,0,0-.633-.321.4.4,0,0,0-.291.122",
    transform: "translate(-402.245 -77.576)",
    fill: "#bcd8d9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M398.688,82.15a1.945,1.945,0,0,0-.356,1.01,6.642,6.642,0,0,0,.042,1.208,3.99,3.99,0,0,0,.2.953.9.9,0,0,0,.723.669.754.754,0,0,0,.408-.075.948.948,0,0,0,.3-.285.89.89,0,0,0,.054-.87,6.773,6.773,0,0,0-.4-.8c-.181-.326-.392-.632-.531-.916a1.634,1.634,0,0,1-.2-.8,1.071,1.071,0,0,1,.079-.377,1.03,1.03,0,0,0-.31.286",
    transform: "translate(-398.317 -81.864)",
    fill: "#bcd8d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1739",
    "data-name": "Group 1739",
    transform: "translate(-906.538 -77.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1739-2",
    "data-name": "Group 1739",
    transform: "translate(906.538 104.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 73.531,
    height: 62.279,
    transform: "translate(-7.31 67.179) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1740",
    "data-name": "Group 1740",
    transform: "translate(931.752 120.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 236.596,
    height: 28.209,
    transform: "translate(-25.475 234.939) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1741",
    "data-name": "Group 1741",
    transform: "translate(926.437 176.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 14.579,
    height: 14.579,
    transform: "translate(-1.418 13.076) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1742",
    "data-name": "Group 1742",
    transform: "translate(930.109 241.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 6.484,
    height: 6.484,
    transform: "translate(-0.631 5.816) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1743",
    "data-name": "Group 1743",
    transform: "translate(928.728 303.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 9.53,
    height: 9.53,
    transform: "translate(-0.927 8.548) rotate(-83.812)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1744",
    "data-name": "Group 1744",
    transform: "translate(925.902 209.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 15.756,
    height: 15.756,
    transform: "translate(-1.532 14.132) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1745",
    "data-name": "Group 1745",
    transform: "translate(944.564 77.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 62.254,
    height: 73.536,
    transform: "translate(-5.929 54.606) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    "data-name": "Group 1746",
    transform: "translate(960.192 102.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 28.209,
    height: 236.597,
    transform: "translate(-0.279 2.569) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    "data-name": "Group 1747",
    transform: "translate(1016.032 97.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 14.58,
    height: 14.579,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, -1.418, 13.077)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1748",
    "data-name": "Group 1748",
    transform: "translate(1081.632 100.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 6.485,
    height: 6.485,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, -0.631, 5.816)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749",
    transform: "translate(1142.768 99.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 9.53,
    height: 9.53,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, -0.927, 8.548)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1750",
    "data-name": "Group 1750",
    transform: "translate(1049.574 96.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 15.756,
    height: 15.756,
    transform: "translate(-1.532 14.132) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    "data-name": "Group 1751",
    transform: "translate(924.158 84.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 21.106,
    height: 22.126,
    transform: "translate(-2.041 18.819) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752",
    transform: "translate(937.218 154.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 48.947,
    height: 18.052,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, -5.17, 47.272)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753",
    transform: "translate(945.515 164.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 3.5,
    height: 4.041,
    transform: "translate(-0.334 3.081) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754",
    transform: "translate(944.341 165.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 4.014,
    height: 3.826,
    transform: "translate(-0.393 3.621) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1755",
    "data-name": "Group 1755",
    transform: "translate(940.722 163.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 2.011,
    height: 3.919,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, -0.184, 1.595)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756",
    transform: "translate(942.279 165.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 2.408,
    height: 2.407,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, -0.475, 2.16)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757",
    transform: "translate(944.86 163.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 2.326,
    height: 4.328,
    transform: "translate(-0.203 1.868) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1758",
    "data-name": "Group 1758",
    transform: "translate(995.134 109.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 18.037,
    height: 49.204,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, -1.649, 12.778)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759",
    transform: "translate(1005.296 118.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 4.041,
    height: 3.501,
    transform: "translate(-0.399 3.683) rotate(-83.812)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1760",
    "data-name": "Group 1760",
    transform: "translate(1006.747 117.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 3.826,
    height: 4.014,
    transform: "translate(-0.37 3.411) rotate(-83.811)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761",
    transform: "translate(1004.256 113.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 3.909,
    height: 2.023,
    transform: "translate(-0.417 3.712) rotate(-83.81)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762",
    transform: "translate(1006.517 115.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 2.167,
    height: 2.38,
    transform: "translate(-0.208 1.92) rotate(-83.812)",
    fill: "#bcd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763",
    transform: "translate(1004.153 117.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 4.331,
    height: 2.35,
    transform: "matrix(0.108, -0.994, 0.994, 0.108, -0.468, 4.101)",
    fill: "#bcd8d9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIcon);
export default __webpack_public_path__ + "static/media/topIcon.7dbcc2fe29ea7b84c761718dbaa21376.svg";
export { ForwardRef as ReactComponent };